import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { SegmentedControlPropShapeType } from '.';
import { exceptStyledProps } from '../../utils';
import { Container as Button } from '../Button/styles';
import { Colors } from '../Colors';

interface ContainerProp {
  shape: SegmentedControlPropShapeType;
}

export const Container = styled('div', exceptStyledProps('shape'))<ContainerProp>`
  display: flex;

  ${props =>
    props.shape === 'round' &&
    css`
      padding: 0.2rem;
      background-color: ${Colors.ut.inputUp};
      border-radius: 10rem;
    `};

  ${Button} {
    background-clip: padding-box;

    ${props =>
      props.shape === 'default' &&
      css`
        &:not(:first-of-type) {
          border-top-left-radius: 0;
          border-bottom-left-radius: 0;
        }

        &:not(:last-of-type) {
          border-top-right-radius: 0;
          border-bottom-right-radius: 0;
        }
      `};
  }

  & > * + * {
    margin-left: ${props => (props.shape === 'round' ? '0.6rem' : '1px')};
  }
`;
